export default {
  samePasswords: 'Password and confirm password must be the same!',
};
